import {useMutation} from "@tanstack/react-query";
import {removeOfferTemplateNoteMutationOptions} from "./remove-offer-template-note.mutation-options";

export function useRemoveOfferTemplateNote(id: string) {
  return useMutation(removeOfferTemplateNoteMutationOptions(id));
}
